/**
 * FeedbackTriggerButton Component
 *
 * Button to open the feedback sidebar.
 */

import { Lightbulb } from '@tonnie/assets';
import { useTranslation } from '@tonnie/locale';
import { Button, cn } from '@tonnie/ui';

import { useFeedbackSidebar } from '@/core/contexts/FeedbackSidebarContext';

interface IFeedbackTriggerButtonProps {
  className?: string;
}

export function FeedbackTriggerButton({ className }: IFeedbackTriggerButtonProps) {
  const { t } = useTranslation();
  const { toggle, isOpen } = useFeedbackSidebar();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      className={cn(
        'relative',
        isOpen && 'bg-sidebar-accent text-sidebar-accent-foreground',
        className
      )}
      aria-label={t('feedback.toggle')}
      title={t('feedback.toggle')}
      data-testid="feedback-trigger"
    >
      <Lightbulb className="w-5 h-5" aria-hidden="true" />
    </Button>
  );
}
